module.exports = __webpack_public_path__ + "img/6_uk.49c6e46c.svg";